export default "__VITE_ASSET__CzYTkXfi__"